import { clearStoragePreservingRememberedEmail } from "./utils/rememberedLogin";
// src/ProtectedRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import useAccess from "./hooks/useAccess";
import { isAdmin } from "./utils/accessUtils";
import { resolveRoutePermission } from "./config/permissionRegistry";

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload.exp < Date.now() / 1000;
  } catch {
    return true;
  }
};

const ProtectedRoute = ({
  children,
  adminOnly = false,
  page,
  resource,
  action,
}) => {
  const token = localStorage.getItem("token");
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const location = useLocation();

  const { hasPermission, hasAnyPagePermission, permissionsLoaded } = useAccess();

  if (!userId || !token) return <Navigate to="/" replace />;

  if (isTokenExpired(token)) {
    clearStoragePreservingRememberedEmail();
    alert("Session expired, please log in again.");
    return <Navigate to="/" replace />;
  }

  if (adminOnly && !isAdmin(userRole)) {
    return (
      <div className="container py-5 text-center">
        <h4 className="text-danger">Access Denied</h4>
        <p>You do not have permission to view this page.</p>
      </div>
    );
  }

  const resolvedPermission =
    page && resource
      ? { page, resource }
      : resolveRoutePermission(location.pathname, location.search);
  const requiredAction = action || "view";

  if (isAdmin(userRole) && resolvedPermission) {
    if (!permissionsLoaded) {
      return (
        <div className="container py-5 text-center">
          <p>Checking access...</p>
        </div>
      );
    }

    const allowed =
      resolvedPermission.resource === "*"
        ? hasAnyPagePermission(resolvedPermission.page, requiredAction)
        : hasPermission(
            resolvedPermission.page,
            resolvedPermission.resource,
            requiredAction,
          );
    if (!allowed) {
      return (
        <div className="container py-5 text-center">
          <h4 className="text-danger">Access Denied</h4>
          <p>You do not have permission to view this page.</p>
        </div>
      );
    }
  }

  return children;
};

export default ProtectedRoute;
